<div class="content" [ngClass]="{'loading': isLoading | async}" > 
    <ng-content></ng-content>
    <div class="blocked">
        <mat-spinner [diameter]="44"></mat-spinner>
    </div>
</div> 
